/*
Type guard to check if the api response was an Error
and if the response was a valid ACS token
*/
import { AcsTokenError, AcsToken } from "../acsToken.types";

export function isApiResponseError(
  apiResponse: AcsTokenError | AcsToken
): apiResponse is AcsTokenError {
  if (!apiResponse) {
    return false;
  }
  return (apiResponse as AcsTokenError).isError !== undefined;
}

export function isACSToken(
  apiResponse: AcsTokenError | AcsToken
): apiResponse is AcsToken {
  if (!apiResponse) {
    return false;
  }
  return (apiResponse as AcsToken).token !== undefined;
}
